import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { PRIVATE_ROUTES, PUBLIC_ROUTES } from 'routes/routesConfig';
import { isAuthenticatedUserSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { mixpanelTrack } from 'utils/mixpanel/mixpanel';
import { EMixpanelDataKeys, EMixpanelEvents } from 'utils/mixpanel/mixpanelTypes';

const withRoutes = (Component) => () => {
  const { search, pathname } = useLocation();
  const isAuthenticatedUser = useTypedSelector(isAuthenticatedUserSelector);
  const routes = isAuthenticatedUser ? PRIVATE_ROUTES : PUBLIC_ROUTES;
  const routesProps = { search, routes };
  const location = pathname + search;

  useEffect(() => {
    mixpanelTrack(EMixpanelEvents.ViewPage, { [EMixpanelDataKeys.PagePath]: location });
  }, [location]);

  return <Component {...routesProps} />;
};

export default withRoutes;
